/**
 * API types generated from OpenAPI schema.
 * Do not edit by hand. Regenerate with: npm run generate:api-types
 */

/* eslint-disable @typescript-eslint/no-explicit-any */

export interface PriceResponseDto {
  instrument: string;
  symbol: string;
  formattedPrice?: string;
  change?: number;
  formattedChange?: string;
  changePercent?: number;
  formattedChangePercent?: string;
  volume?: number;
  formattedVolume?: string;
  timestamp?: string;
  trend?: string;
  ref_price?: number;
  ceiling_price?: number;
  floor_price?: number;
  latest_matched_price?: number;
  latest_matched_quantity?: number;
  ref_diff_abs?: number;
  ref_diff_pct?: number;
  total_matched_quantity?: number;
  open_price?: number;
  latest_estimated_matched_price?: number;
  highest_price?: number;
  lowest_price?: number;
  average_price?: number;
  open_interest?: number;
  foreign_buy_quantity?: number;
  foreign_sell_quantity?: number;
  foreign_room?: number;
  close_price?: number;
  maturity_date?: string;
  hidden_system_status?: string;
  datetime_str?: string;
  timestamp_unix?: number;
  source_timestamp_unix?: number;
  price_timestamp_unix?: number;
  price_age_ms?: number;
  bid_price_1?: number;
  bid_quantity_1?: number;
  ask_price_1?: number;
  ask_quantity_1?: number;
  bid_price_2?: number;
  bid_quantity_2?: number;
  ask_price_2?: number;
  ask_quantity_2?: number;
  bid_price_3?: number;
  bid_quantity_3?: number;
  ask_price_3?: number;
  ask_quantity_3?: number;
  bid_price_4?: number;
  bid_quantity_4?: number;
  ask_price_4?: number;
  ask_quantity_4?: number;
  bid_price_5?: number;
  bid_quantity_5?: number;
  ask_price_5?: number;
  ask_quantity_5?: number;
  bid_price_6?: number;
  bid_quantity_6?: number;
  ask_price_6?: number;
  ask_quantity_6?: number;
  bid_price_7?: number;
  bid_quantity_7?: number;
  ask_price_7?: number;
  ask_quantity_7?: number;
  bid_price_8?: number;
  bid_quantity_8?: number;
  ask_price_8?: number;
  ask_quantity_8?: number;
  bid_price_9?: number;
  bid_quantity_9?: number;
  ask_price_9?: number;
  ask_quantity_9?: number;
  bid_price_10?: number;
  bid_quantity_10?: number;
  ask_price_10?: number;
  ask_quantity_10?: number;
}

export interface OhlcCandleDto {
  time: string;
  open: number;
  high: number;
  low: number;
  close: number;
  volume?: number;
}

export interface PriceChartResponseDto {
  tickerSymbol: string;
  exchangeId?: string;
  timeScale: string;
  ohlc: Array<OhlcCandleDto>;
  nextCursor?: string;
}

export interface SetSpecialDaysDto {
  specialDays: Array<string>;
}

export interface SignupDto {
  email: string;
  name?: string;
}

export interface LoginDto {
  email: string;
  password: string;
}

export interface AuthResponseDto {
  accessToken: string;
  refreshToken: string;
}

export interface RefreshTokenDto {
  refreshToken: string;
}

export interface ForgotPasswordDto {
  email: string;
}

export interface VerifyResetCodeDto {
  email: string;
  code: string;
}

export interface ResetPasswordDto {
  email: string;
  code: string;
  newPassword: string;
}

export interface CreateWhitelistEntryDto {
  pattern: string;
  createdBy?: string;
}

export interface UserResponseDto {
  id: string;
  email: string;
  name: string;
  role: string;
  createdAt: string;
  updatedAt: string;
}

export interface RegisterPortfolioDto {
  brokerCode: string;
  portfolioId: string;
  portfolioName?: string;
}

export interface BrokerResponseDto {
  id: string;
  code: string;
  name: string;
  description?: string;
  apiUrl?: string;
  isActive: boolean;
  createdAt: string;
  updatedAt: string;
}

export interface RegisteredPortfolioResponseDto {
  id: string;
  userId: string;
  broker: unknown;
  portfolioId: string;
  portfolioName?: string;
  createdAt: string;
  updatedAt: string;
}

export interface SyncHoldingsDto {
  portfolioIds: Array<string>;
}

export interface CreatePortfolioDto {
  portfolioId: string;
  brokerCode?: string;
  portfolioName?: string;
  accountType?: string;
  portfolios: Array<string>;
  status?: string;
}

export interface PortfolioResponseDto {
  id: string;
  portfolioId: string;
  brokerCode?: string;
  portfolioName?: string;
  portfolios: Array<string>;
  date: {
  [key: string]: unknown;
};
  userId: string;
  status?: string;
  isActive?: boolean;
}

export interface PortfolioIdResponseDto {
  id: string;
  name?: string;
  accountType: string;
}

export interface HoldingSnapshotDto {
  id: string;
  capturedAt: string;
  holding: {
  [key: string]: unknown;
};
}

export interface HoldingReportRowDto {
  snapshotId: string;
  capturedAt: string;
  exchange: string;
  symbol: string;
  quantity: string;
  cost: string;
}

export interface CurrentBalanceDto {
  availablebalance: number;
  netreceivableamount: number;
  secureamount: number;
  cashdividend: number;
}

export interface BalanceResponseDto {
  pid: string;
  brokerCode?: string;
  purchasingpower: number;
  cash?: number;
  reservedCash?: number;
  totalmarketvalue?: number;
  withdrawalamount: number;
  totalassets: number;
  netassetvalue: number;
  liabilities: number;
  roundingerror: number;
  currentbalance: CurrentBalanceDto;
}

export interface AvailableCashDto {
  portfolioId: string;
  purchasingPower: number;
  cash: number;
  reservedCash: number;
  committed: number;
  inHoldings: number;
  idle: number;
  available: number;
}

export interface AccountingPortfolioItemDto {
  symbol: string;
  quantity: number;
  availableqty?: number;
  deliverableqty?: number;
  price_hold?: number;
}

export interface AccountingResponseDto {
  portfolio_id: string;
  purchasing_power: string;
  portfolio: Array<AccountingPortfolioItemDto>;
}

export interface VerifyWithDbResponseDto {
  equal: boolean;
  purchasingPowerMatch: boolean;
  portfolioMatch: boolean;
  message?: string;
}

export interface HoldingValueItemDto {
  symbol: string;
  quantity: number;
  price: number;
  value: number;
}

export interface MaxCapacityResponseDto {
  portfolioId: string;
  symbol: string;
  symbolPrice: number;
  purchasingPower: number;
  holdingsValue: number;
  maxCapacity: number;
  holdings: Array<HoldingValueItemDto>;
}

export interface ExecutionResponseDto {
  id: string;
  userId: string;
  strategyId: string;
  portfolioId?: string;
  portfolioName?: string;
  executionDate: string;
  status: string;
  logFilePath?: string;
  createdAt: string;
  updatedAt: string;
}

export interface BotTransactionDto {
  id: string;
  instrument_id: string;
  txn_type: string;
  size: string;
  matched_price: string;
  capital: string;
  fee?: string;
  matched_timestamp: number;
  raw: {
  [key: string]: unknown;
};
}

export interface BotPositionEventDto {
  id: string;
  position_id: string;
  instrument_id: string;
  transaction_id?: string;
  size: string;
  realized_pnl?: string;
  closed_at: string;
  raw: {
  [key: string]: unknown;
};
}

export interface BotPositionSnapshotDto {
  id: string;
  instrument_id: string;
  strategy_id?: string;
  type: string;
  opened_at: string;
  closed_at?: string;
  opening_amount: string;
  closing_amount: string;
  capital: string;
  realized_pnl?: string;
  open_cost?: string;
  price_hold?: string;
  raw: {
  [key: string]: unknown;
};
}

export interface BotArchiveSyncDto {
  portfolio_id: string;
  transactions?: Array<BotTransactionDto>;
  events?: Array<BotPositionEventDto>;
  snapshots?: Array<BotPositionSnapshotDto>;
}

export interface InstrumentConfigResponseDto {
  id: string;
  dataConfigId: string;
  exchange: string;
  symbol: string;
  settings: {
  [key: string]: unknown;
};
  initialCapital: string;
  currentCapital: string;
  netDeposits: string;
  realizedCredited: string;
  holdingsCost: string;
  heldQty: string;
  realizedPnl: string;
  effectiveCapital: string;
  marketValue?: string;
  marketPrice?: number;
  status: string;
  createdAt: string;
  updatedAt: string;
  instrumentId?: string;
}

export interface InstrumentConfigAggregatesDto {
  totalDeposited: string;
  totalNetDeposits: string;
  totalRealizedCredited: string;
  positionCost: string;
  pageMarketValue: string;
}

export interface InstrumentConfigListResponseDto {
  items: Array<InstrumentConfigResponseDto>;
  total: number;
  page: number;
  pageSize: number;
  aggregates: unknown;
}

export interface InstrumentConfigTransactionDto {
  id: string;
  instrumentConfigId: string;
  type: string;
  amount: string;
  status: string;
  requestedAt: string;
  completedAt?: string;
  failureReason?: string;
  createdBy: string;
}

export interface InstrumentConfigTransactionListResponseDto {
  items: Array<InstrumentConfigTransactionDto>;
  totalDeposited: string;
  totalWithdrawn: string;
  pendingDeposit: string;
  pendingWithdraw: string;
  total: number;
}

export interface DepositInstrumentConfigDto {
  amount: number;
  idempotency_key?: string;
}

export interface WithdrawInstrumentConfigDto {
  amount: number;
  idempotency_key?: string;
}

export interface InstrumentConfigCallbackDto {
  request_id: string;
  instrument_config_id: string;
  type: string;
  status: string;
  portfolio_id?: string;
  ts?: number;
  new_pp?: string;
  actual_amount?: string;
  reason?: string;
  freed?: string;
  realized_pnl?: string;
  new_holdings_cost?: string;
  new_held_qty?: string;
  bot_timestamp?: string;
}

export interface HoldingsSnapshotDto {
  new_holdings_cost: string;
  new_held_qty: string;
  bot_timestamp: string;
  strategy_execution_id: string;
  realized_pnl?: string;
  avg_entry_price?: string;
}

export interface ArchetypeIdsResponseDto {
  archepids: Array<string>;
}

export interface ArchetypePortfolioDto {
  [key: string]: unknown;
}

export interface ArchetypeResponseDto {
  archetypeportfolio: unknown;
}

export interface CreateArchetypePortfolioDto {
  sid: string;
  archetypeportfolio: unknown;
}

export interface ArchetypeIdResponseDto {
  archepid: string;
}

export interface CreateArchetypeMapperDto {
  archetypePrefix: string;
  strategyType: string;
}

export interface ArchetypeMapperResponseDto {
  id: string;
  archetypePrefix: string;
  strategyType: string;
  createdAt: string;
  updatedAt: string;
}

export interface RollFuturesSymbolDto {
  instrument_config_id: string;
  new_symbol: string;
  old_symbol?: string;
  new_reference_price?: number;
  basis?: number;
  bot_timestamp?: string;
  strategy_execution_id?: string;
}

export interface RollDerivLegDto {
  new_symbol: string;
  new_reference_price: number;
}

export interface PairActiveResponseDto {
  dataConfigId: string;
}

export interface PairCashCapacityResponseDto {
  maxDeposit: string;
  maxWithdraw: string;
  stockIdle: string;
  derivIdle: string;
  stockAllocated: string;
  derivAllocated: string;
  marginRate: number;
  splitFraction: {
  [key: string]: unknown;
};
  botActive: boolean;
  pairBotActive: boolean;
  warnings: Array<string>;
}

export interface PairCashOpDto {
  amount: number;
}

export interface PairStopResponseDto {
  status: string;
}

export interface PairCloseResponseDto {
  closed: number;
}

export interface PairStockLegDto {
  portfolioId: string;
  allocatedCash: number;
}

export interface PairDerivLegDto {
  portfolioId: string;
  allocatedCash: number;
  futures_exchange: string;
  futures_symbol: string;
}

export interface PlacePairDto {
  is_starting: boolean;
  stockLeg: unknown;
  derivLeg: unknown;
  balance_mode?: string;
  strategy_type: string;
  close_type: string;
  take_profit_return: number;
  cut_loss_return: number;
  max_open: number;
  max_holding_days?: number;
  active_side?: string;
  future_instrument_price?: number;
  is_pause?: boolean;
  stock_proportion: {
  [key: string]: unknown;
};
  date?: string;
}

export interface UpdatePairSettingsDto {
  portfolio: string;
  settings?: {
  [key: string]: unknown;
};
}

export interface PairBotOrderDto {
  clientOrderId: string;
  serverOrderId?: string;
  leg: string;
  instrument: string;
  symbol: string;
  side: string;
  orderType: string;
  status: string;
  cancelStatus?: string;
  quantity: number;
  matchedQuantity: number;
  limitPrice?: number;
  avgPrice?: number;
  lastModified?: number;
  isFinal: boolean;
  ageSeconds: number;
  strategyId?: string;
}

export interface PairBotOrdersResponseDto {
  success: boolean;
  pid: string;
  date: string;
  liveCount: number;
  stalledCount: number;
  orders: Array<PairBotOrderDto>;
}

export interface PortfolioMappingDto {
  externalPortfolioId: string;
  accountType: string;
  userId: string;
  userName: string;
  pairedWith: string;
  dataConfigId: string;
  redisNamespace: string;
}

export interface StrategyOptionDto {
  id: string;
  name: string;
  type: string;
  status: string;
}

export interface CsvOrderRowDto {
  from_sender_order_id: string;
  username: string;
  security_exchange: string;
  symbol: string;
  side: string;
  stock_type?: string;
  status: string;
  quantity: string;
  filled_quantity: string;
  avg_price: string;
  price?: string;
  transaction_time?: string;
  sending_time?: string;
  first_feedback?: string;
  external_order_id?: string;
  from_sender?: string;
  time_in_force?: string;
  account?: string;
}

export interface AnalyzeSyncRequestDto {
  csvRows: Array<CsvOrderRowDto>;
  dateFilter?: string;
  botName?: string;
}

export interface RedisKeyInfoDto {
  key: string;
  type: string;
  ttl: number;
}

export interface RedisKeyValueDto {
  key: string;
  type: string;
  ttl: number;
  value: string;
  members?: Array<string>;
}

export interface PairConfigDto {
  maxContracts?: number;
  maxHoldingDays?: number;
  notionalTolerancePct?: number;
}

export interface GridConfigDto {
  gridOrigin?: number;
  gridInterval?: number;
  tick?: number;
  priceTolerance?: number;
}

export interface PairingDto {
  pairId: string;
  longPositionIds: Array<string>;
  shortPositionIds: Array<string>;
  bookSide: string;
}

export interface PlanRequestDto {
  pid: string;
  archepid: string;
  purchasingpower: number;
  withdrawalamount: number;
  liabilities: number;
  totalassets: number;
  netassetvalue: number;
  roundingerror: number;
  currentbalance: CurrentBalanceDto;
  portfolio: Array<PortfolioItemDto>;
}

export interface ApplySyncRequestDto {
  actionsByNamespace: {
  [key: string]: unknown;
};
  auditNote?: string;
  strategyOverrides?: {
  [key: string]: unknown;
};
  edits?: Array<string>;
  pairingsByNamespace?: {
  [key: string]: unknown;
};
  configByNamespace?: {
  [key: string]: unknown;
};
  writeAccountingDeltas?: boolean;
}

export interface StockSearchResultDto {
  symbol: string;
  price: number;
  latestChange: number;
  changePercent?: number;
}

export interface StockSearchResponseDto {
  results: Array<StockSearchResultDto>;
  count: number;
}

export interface FutureContractSearchResultDto {
  symbol: string;
  latestChange: number;
  maturityDate?: string;
}

export interface FutureContractSearchResponseDto {
  results: Array<FutureContractSearchResultDto>;
  count: number;
}

export interface OrderItemDto {
  orderId: string;
  clOrdId: string;
  accountId: string;
  symbol: string;
  securityExchange: string;
  envId: string;
  side: string;
  ordType: string;
  timeInForce: string;
  price: number;
  orderQty: number;
  leavesQty: number;
  cumQty: number;
  avgPx: number;
  ordStatus: string;
  statusCode: string;
  statusText: string;
  orderDate: string;
  lastUpdateDate: string;
  lastExecId: string;
  costEachQty: number;
  isCancelled: boolean;
  isExecuting: boolean;
  createdAt: string;
}

export interface OrdersResponseDto {
  success: boolean;
  items: Array<OrderItemDto>;
}

export interface ProfitSummaryDto {
  totalProfit: number;
  totalProfitPercentage: number;
  currentNav: number;
  initialNav: number;
  recordCount: number;
  firstBalanceDate: string;
  lastBalanceDate: string;
  intradayRealizedPnL?: number;
  intradayUnrealizedPnL?: number;
  intradayTotalPnL?: number;
  currentTotalRealized?: number;
  currentTotalUnrealized?: number;
  currentTotalPnL?: number;
}

export interface MddResponseDto {
  max_drawdown_pct?: number;
  peak_date?: string;
  trough_date?: string;
  peak_nav?: number;
  trough_nav?: number;
  num_periods?: number;
}

export interface SharpeResponseDto {
  sharpe_ratio?: number;
  annualized_return?: number;
  annualized_volatility?: number;
  num_periods?: number;
  risk_free_rate?: number;
}

export interface PerformanceMetricsDto {
  mdd?: unknown;
  sharpe?: unknown;
}

export interface CreateBrokerDto {
  code: string;
  name: string;
  description?: string;
  apiUrl?: string;
  isActive?: boolean;
}

export interface CreateStrategyDto {
  name: string;
  type: string;
  description?: string;
  config?: {
  [key: string]: unknown;
};
  plutusUrl?: string;
  features?: Array<string>;
}

export interface StrategyResponseDto {
  id: string;
  name: string;
  type: string;
  description?: string;
  config?: {
  [key: string]: unknown;
};
  plutusUrl?: string;
  features?: Array<string>;
  status: string;
  createdBy?: string;
  approvedBy?: string;
  publishedBy?: string;
  approvedAt?: string;
  publishedAt?: string;
  rejectedAt?: string;
  rejectionReason?: string;
  createdAt: string;
  updatedAt: string;
}

export interface PaginationMetaDto {
  page: number;
  limit: number;
  total: number;
  totalPages: number;
  hasNext: boolean;
  hasPrev: boolean;
}

export interface PaginatedStrategyResponseDto {
  data: Array<StrategyResponseDto>;
  meta: unknown;
}

export interface AllowStrategyDto {
  status: string;
  comment?: string;
}

export interface RejectStrategyDto {
  reason: string;
}

export interface SubscriptionResponseDto {
  id: string;
  userId: string;
  sid: string;
  isExpired: boolean;
  createdAt: string;
  updatedAt: string;
}

export interface CreateSubscriptionDto {
  userId: string;
  sid: string;
}

export interface PortfolioItemDto {
  symbol: string;
  quantity: number;
  availableqty: number;
  deliverableqty: number;
  stockdividend: number;
  capital: number;
}

export interface TradingTargetDto {
  BUY: {
  [key: string]: unknown;
};
  SELL: {
  [key: string]: unknown;
};
}

export interface PlanResponseDto {
  tradingtarget: unknown;
}

export interface CreateGridConfigDto {
  name?: string;
  portfolioId?: string;
  configData: {
  [key: string]: unknown;
};
}

export interface GridConfigResponseDto {
  id: string;
  name?: string;
  configData: {
  [key: string]: unknown;
};
  portfolioId?: string;
  createdAt: string;
  updatedAt: string;
}

export interface GridConfigListItemDto {
  id: string;
  name?: string;
}

export interface GridPositionResponseDto {
  data: {
  [key: string]: unknown;
};
}

export interface GridSymbolProfitDto {
  symbol: string;
  instrumentId: string;
  grossPnl: number;
  creditPnl: number;
  fee: number;
  netPnl: number;
  positionCount: number;
}

export interface GridUncountedCreditDto {
  groupId: string;
  symbol: string;
  cashPerShare: number;
  exDate: string;
  appliedAt: string;
}

export interface GridProfitSummaryDto {
  grossPnl: number;
  creditPnl: number;
  totalFee: number;
  netPnl: number;
  bySymbol: Array<GridSymbolProfitDto>;
  firstClosedAt: string;
  lastClosedAt: string;
  dataGapBefore: string;
  uncountedCredits: Array<GridUncountedCreditDto>;
}

export interface GridDailyProfitPointDto {
  date: string;
  grossPnl: number;
  creditPnl: number;
  fee: number;
  netPnl: number;
}

export interface GridDailyProfitResponseDto {
  points: Array<GridDailyProfitPointDto>;
  cumulativeNetPnl: number;
}

export interface GridCreditDto {
  id: string;
  symbol: string;
  kind: string;
  amount: number;
  heldQty: number;
  cashPerShare: number;
  exDate: string;
  groupId: string;
  taxRate: number;
  source: string;
}

export interface GridClosedPositionDto {
  positionId: string;
  symbol: string;
  type: string;
  gridPoint: number;
  openedAt: string;
  closedAt: string;
  closedAtSource: string;
  closedQty: number;
  avgEntryPrice: number;
  avgExitPrice: number;
  exitPriceSource: string;
  capital: number;
  realizedPnl: number;
  fee: number;
  dividendPnl: number;
  adjustedEntryPrice: number;
}

export interface GridClosedPositionsResponseDto {
  items: Array<GridClosedPositionDto>;
  credits: Array<GridCreditDto>;
  total: number;
  page: number;
  pageSize: number;
}

export interface UpdateGridConfigDto {
  name?: string;
  configData?: {
  [key: string]: unknown;
};
}

export interface StopGridBotDto {
  portfolioId: string;
  symbol: string;
}

export interface CreateDailyScheduleDto {
  portfolioId: string;
  strategyId: string;
  cronDaily: string;
  isActive: boolean;
}

export interface DailyScheduleResponseDto {
  id: string;
  portfolioName?: string;
  strategyId: string;
  isActive: boolean;
  cronDaily: string;
  createdAt: string;
  updatedAt: string;
}

export interface UpdateDailyScheduleDto {
  cronDaily?: string;
  isActive?: boolean;
}

export interface CreateTournamentDto {
  name: string;
  tournamentStart: string;
  tournamentEnd: string;
  isActive: boolean;
}

export interface TournamentResponseDto {
  id: string;
  name: string;
  tournamentStart: string;
  tournamentEnd: string;
  isActive: boolean;
  participantCount: number;
  closedAt?: string;
  final: boolean;
  createdAt: string;
  updatedAt: string;
}

export interface UpdateTournamentDto {
  name?: string;
  tournamentStart?: string;
  tournamentEnd?: string;
  isActive?: boolean;
}

export interface CreateParticipantDto {
  userId: string;
  portfolioId: string;
  startingCash: number;
}

export interface ParticipantResponseDto {
  id: string;
  tournamentId: string;
  userId: string;
  portfolioId: string;
  startingCash: number;
  createdAt: string;
  updatedAt: string;
}

export interface RankingEntryDto {
  name: string;
  rank: number;
  pnl: number;
  unrealizedPnL?: number;
  incomplete?: boolean;
  portfolios?: string[];
  previousRank?: number;
  rankDelta?: number;
  rankReference?: string;
  asOf?: string;
}

export interface ExecutionStoppedDto {
  reason?: string;
}

export interface AdminBotRowDto {
  executionId: string;
  userId: string;
  userEmail?: string;
  userName?: string;
  configType: string;
  dataConfigId: string;
  dataConfigName?: string;
  portfolioId?: string;
  externalPortfolioId?: string;
  strategyId: string;
  status: string;
  executionDate: string;
  lastHeartbeatAt?: string;
  createdAt: string;
  updatedAt: string;
  canRestart: boolean;
  canStop: boolean;
}

export interface RestartAllBotsDto {
  executionIds?: Array<string>;
  configType?: string;
}

export interface BulkActionResultItemDto {
  executionId: string;
  dataConfigId: string;
  configType: string;
  ok: boolean;
  error?: string;
}

export interface BulkActionResultDto {
  requested: number;
  succeeded: number;
  failed: number;
  items: Array<BulkActionResultItemDto>;
}

export interface AdminPortfolioStrategyDto {
  strategyId: string;
  strategyName: string;
  configType: string;
  dataConfigId: string;
  dataConfigName: string;
  hasLiveExecution: boolean;
  executionId?: string;
  executionStatus?: string;
}

export interface AdminPortfolioRowDto {
  portfolioId: string;
  externalPortfolioId: string;
  accountType: string;
  brokerCode: string;
  userId: string;
  userEmail: string;
  userName: string;
  strategies: Array<AdminPortfolioStrategyDto>;
}

export interface CancelAllOrdersDto {
  portfolioId: string;
  symbol?: string;
  note?: string;
}

export interface CancelOneOrderDto {
  portfolioId: string;
  clientOrderId: string;
  note?: string;
}

export interface ManualOrderDto {
  portfolioId: string;
  strategyId?: string;
  symbol: string;
  side: string;
  qty: number;
  price?: number;
  note?: string;
}

export interface GridLevelDto {
  side: string;
  pricePoint: string;
  positionId: string;
  quantity: number;
  capital: number;
  priceHold: number;
}

export interface GridSymbolStateDto {
  symbol: string;
  netLong: number;
  netShort: number;
  net: number;
  levels: Array<GridLevelDto>;
}

export interface GridStateDto {
  pid: string;
  symbols: Array<GridSymbolStateDto>;
}

export interface PairRedisKeyDto {
  key: string;
  label: string;
  exists: boolean;
  ttl: number;
  value: {
  [key: string]: unknown;
};
}

export interface PairRedisStateDto {
  pid: string;
  keys: Array<PairRedisKeyDto>;
}

export interface PairPositionDto {
  pairId: string;
  instrument: string;
  exchangeId: string;
  tickerSymbol: string;
  openingAmount: number;
  quantity: number;
  capital: number;
  priceHold: number;
  realizedPnl: number;
}

export interface PairPositionsDto {
  pid: string;
  deriv: Array<PairPositionDto>;
  basis: Array<PairPositionDto>;
}

export interface AiSkillDto {
  name: string;
  description: string;
}

export interface AiHealthResponseDto {
  ok: boolean;
  llmBaseUrl: string;
  llmModel?: string;
  skills: Array<AiSkillDto>;
}

export interface AiChatRequestDto {
  message: string;
  maxSteps?: number;
}

export interface AiTraceStepDto {
  tool: string;
  arguments?: string;
  result: {
  [key: string]: unknown;
};
}

export interface AiChatResponseDto {
  answer: string;
  steps: number;
  trace: Array<AiTraceStepDto>;
}
/** API operations: route, method, and request/response type names */
export interface ApiOperation {
  path: string;
  method: string;
  operationId: string | null;
  requestType: string | null;
  responseType: string | null;
}

export const API_OPERATIONS: ApiOperation[] = [
  { path: "/price/latest/{symbol}", method: "get", operationId: "PriceController_getLatestPrice", requestType: null, responseType: "PriceResponseDto" },
  { path: "/price/chart", method: "get", operationId: "PriceController_getPriceChart", requestType: null, responseType: "PriceChartResponseDto" },
  { path: "/price/ohlc/build", method: "post", operationId: "PriceController_buildAllOhlc", requestType: null, responseType: null },
  { path: "/price/ohlc/build/{timeframe}", method: "post", operationId: "PriceController_buildOhlcByTimeframe", requestType: null, responseType: null },
  { path: "/special-days/reset", method: "post", operationId: "SpecialDaysController_resetSpecialDays", requestType: null, responseType: null },
  { path: "/special-days", method: "get", operationId: "SpecialDaysController_getSpecialDays", requestType: null, responseType: null },
  { path: "/special-days", method: "post", operationId: "SpecialDaysController_setSpecialDays", requestType: "SetSpecialDaysDto", responseType: null },
  { path: "/auth/signup", method: "post", operationId: "AuthController_signup", requestType: "SignupDto", responseType: null },
  { path: "/auth/login", method: "post", operationId: "AuthController_login", requestType: "LoginDto", responseType: "AuthResponseDto" },
  { path: "/auth/refresh", method: "post", operationId: "AuthController_refresh", requestType: "RefreshTokenDto", responseType: null },
  { path: "/auth/logout", method: "post", operationId: "AuthController_logout", requestType: "RefreshTokenDto", responseType: null },
  { path: "/auth/forgot-password", method: "post", operationId: "AuthController_forgotPassword", requestType: "ForgotPasswordDto", responseType: null },
  { path: "/auth/verify-code", method: "post", operationId: "AuthController_verifyResetCode", requestType: "VerifyResetCodeDto", responseType: null },
  { path: "/auth/reset-password", method: "post", operationId: "AuthController_resetPassword", requestType: "ResetPasswordDto", responseType: null },
  { path: "/email-whitelist", method: "get", operationId: "EmailWhitelistController_list", requestType: null, responseType: null },
  { path: "/email-whitelist", method: "post", operationId: "EmailWhitelistController_add", requestType: "CreateWhitelistEntryDto", responseType: null },
  { path: "/email-whitelist/{id}", method: "delete", operationId: "EmailWhitelistController_remove", requestType: null, responseType: null },
  { path: "/users/me", method: "get", operationId: "UsersController_getMe", requestType: null, responseType: "UserResponseDto" },
  { path: "/users", method: "get", operationId: "UsersController_findAll", requestType: null, responseType: null },
  { path: "/registered-portfolios", method: "get", operationId: "RegisteredPortfoliosController_getRegisteredPortfolios", requestType: null, responseType: "Array<RegisteredPortfolioResponseDto>" },
  { path: "/registered-portfolios", method: "post", operationId: "RegisteredPortfoliosController_registerPortfolio", requestType: "RegisterPortfolioDto", responseType: "RegisteredPortfolioResponseDto" },
  { path: "/registered-portfolios/{id}", method: "get", operationId: "RegisteredPortfoliosController_getRegisteredPortfolio", requestType: null, responseType: "RegisteredPortfolioResponseDto" },
  { path: "/registered-portfolios/{id}", method: "delete", operationId: "RegisteredPortfoliosController_deleteRegisteredPortfolio", requestType: null, responseType: null },
  { path: "/portfolios/sync-holdings", method: "post", operationId: "PortfoliosController_syncHoldings", requestType: "SyncHoldingsDto", responseType: null },
  { path: "/portfolios/{userId}", method: "post", operationId: "PortfoliosController_create", requestType: "CreatePortfolioDto", responseType: "PortfolioResponseDto" },
  { path: "/portfolios", method: "get", operationId: "PortfoliosController_findAll", requestType: null, responseType: "Array<PortfolioIdResponseDto>" },
  { path: "/portfolios/admin/all", method: "get", operationId: "PortfoliosController_findAllAdmin", requestType: null, responseType: null },
  { path: "/portfolios/{id}/holdings", method: "get", operationId: "PortfoliosController_holdingHistory", requestType: null, responseType: "Array<HoldingSnapshotDto>" },
  { path: "/portfolios/{id}/holdings/report", method: "get", operationId: "PortfoliosController_holdingReport", requestType: null, responseType: "Array<HoldingReportRowDto>" },
  { path: "/portfolios/{id}", method: "get", operationId: "PortfoliosController_findOne", requestType: null, responseType: "PortfolioResponseDto" },
  { path: "/balance", method: "get", operationId: "BalanceController_getBalance", requestType: null, responseType: "BalanceResponseDto" },
  { path: "/balance/available", method: "get", operationId: "BalanceController_getAvailableCash", requestType: null, responseType: "AvailableCashDto" },
  { path: "/accounting", method: "get", operationId: "AccountingController_getAccounting", requestType: null, responseType: "AccountingResponseDto" },
  { path: "/accounting/fortuna", method: "get", operationId: "AccountingController_checkWithFortuna", requestType: null, responseType: "AccountingResponseDto" },
  { path: "/accounting/pinetree-db", method: "get", operationId: "AccountingController_getAccountingViaPinetreeDb", requestType: null, responseType: "AccountingResponseDto" },
  { path: "/accounting/verify-with-db", method: "get", operationId: "AccountingController_verifyWithDb", requestType: null, responseType: "VerifyWithDbResponseDto" },
  { path: "/accounting/max-capacity", method: "get", operationId: "AccountingController_getMaxCapacity", requestType: null, responseType: "MaxCapacityResponseDto" },
  { path: "/bot/executions/{id}/log", method: "get", operationId: "BotController_getExecutionLog", requestType: null, responseType: null },
  { path: "/bot/executions", method: "get", operationId: "BotController_getTodayExecutions", requestType: null, responseType: "Array<ExecutionResponseDto>" },
  { path: "/bot-archive/sync", method: "post", operationId: "BotArchiveController_sync", requestType: "BotArchiveSyncDto", responseType: null },
  { path: "/instrument-config", method: "get", operationId: "InstrumentConfigController_list", requestType: null, responseType: "InstrumentConfigListResponseDto" },
  { path: "/instrument-config/by-data-config/{dataConfigId}", method: "get", operationId: "InstrumentConfigController_listByDataConfig", requestType: null, responseType: "InstrumentConfigListResponseDto" },
  { path: "/instrument-config/{id}", method: "get", operationId: "InstrumentConfigController_get", requestType: null, responseType: "InstrumentConfigResponseDto" },
  { path: "/instrument-config/{id}", method: "delete", operationId: "InstrumentConfigController_remove", requestType: null, responseType: "InstrumentConfigResponseDto" },
  { path: "/instrument-config/{id}/transactions", method: "get", operationId: "InstrumentConfigController_transactions", requestType: null, responseType: "InstrumentConfigTransactionListResponseDto" },
  { path: "/instrument-config/deposit-capacity/{portfolioId}", method: "get", operationId: "InstrumentConfigController_depositCapacity", requestType: null, responseType: null },
  { path: "/instrument-config/{id}/deposit", method: "post", operationId: "InstrumentConfigController_deposit", requestType: "DepositInstrumentConfigDto", responseType: null },
  { path: "/instrument-config/{id}/withdraw", method: "post", operationId: "InstrumentConfigController_withdraw", requestType: "WithdrawInstrumentConfigDto", responseType: null },
  { path: "/instrument-config/{id}/withdraw/cancel", method: "post", operationId: "InstrumentConfigController_cancelWithdraw", requestType: null, responseType: null },
  { path: "/instrument-config/callback", method: "post", operationId: "InstrumentConfigController_callback", requestType: "InstrumentConfigCallbackDto", responseType: null },
  { path: "/instrument-config/{id}/holdings-snapshot", method: "post", operationId: "InstrumentConfigController_holdingsSnapshot", requestType: "HoldingsSnapshotDto", responseType: null },
  { path: "/instrument-config/admin/pending-transactions", method: "get", operationId: "InstrumentConfigController_adminListPending", requestType: null, responseType: null },
  { path: "/instrument-config/admin/transactions/{id}/succeed", method: "post", operationId: "InstrumentConfigController_adminForceSucceed", requestType: null, responseType: null },
  { path: "/instrument-config/admin/transactions/{id}/fail", method: "post", operationId: "InstrumentConfigController_adminForceFail", requestType: null, responseType: null },
  { path: "/archetype/strategy/{sid}", method: "get", operationId: "ArchetypeController_getStrategy", requestType: null, responseType: "ArchetypeIdsResponseDto" },
  { path: "/archetype/{archepid}", method: "get", operationId: "ArchetypeController_getArchetype", requestType: null, responseType: "ArchetypeResponseDto" },
  { path: "/archetype", method: "post", operationId: "ArchetypeController_createArchetype", requestType: "CreateArchetypePortfolioDto", responseType: "ArchetypeIdResponseDto" },
  { path: "/archetype/mapper", method: "post", operationId: "ArchetypeController_createArchetypeMapper", requestType: "CreateArchetypeMapperDto", responseType: "ArchetypeMapperResponseDto" },
  { path: "/internal/archetype/strategy/{sid}", method: "get", operationId: "ArchetypeInternalController_getStrategy", requestType: null, responseType: "ArchetypeIdsResponseDto" },
  { path: "/internal/archetype/{archepid}", method: "get", operationId: "ArchetypeInternalController_getArchetype", requestType: null, responseType: "ArchetypeResponseDto" },
  { path: "/internal/archetype/{archetypeId}/strategy", method: "get", operationId: "ArchetypeInternalController_getStrategyFromArchetypeId", requestType: null, responseType: null },
  { path: "/pair/roll-symbol", method: "post", operationId: "PairController_rollSymbol", requestType: "RollFuturesSymbolDto", responseType: null },
  { path: "/pair/{dataConfigId}/roll", method: "post", operationId: "PairController_rollDerivLeg", requestType: "RollDerivLegDto", responseType: null },
  { path: "/pair/active/{portfolioId}", method: "get", operationId: "PairController_getActivePair", requestType: null, responseType: "PairActiveResponseDto" },
  { path: "/pair/{dataConfigId}/cash-capacity", method: "get", operationId: "PairController_pairCashCapacity", requestType: null, responseType: "PairCashCapacityResponseDto" },
  { path: "/pair/{dataConfigId}/deposit", method: "post", operationId: "PairController_depositToPair", requestType: "PairCashOpDto", responseType: null },
  { path: "/pair/{dataConfigId}/flatten", method: "post", operationId: "PairController_flattenPair", requestType: null, responseType: null },
  { path: "/pair/{dataConfigId}/flatten/{requestId}", method: "get", operationId: "PairController_flattenPairResult", requestType: null, responseType: null },
  { path: "/pair/{dataConfigId}/stop", method: "post", operationId: "PairController_stopPair", requestType: null, responseType: "PairStopResponseDto" },
  { path: "/pair/{dataConfigId}/close", method: "delete", operationId: "PairController_closePair", requestType: null, responseType: "PairCloseResponseDto" },
  { path: "/pair/{dataConfigId}/withdraw", method: "post", operationId: "PairController_withdrawFromPair", requestType: "PairCashOpDto", responseType: null },
  { path: "/pair/{dataConfigId}/withdraw/cancel", method: "post", operationId: "PairController_cancelWithdrawFromPair", requestType: null, responseType: null },
  { path: "/pair/allocation/{dataConfigId}/balance", method: "get", operationId: "PairController_pairAllocationBalance", requestType: null, responseType: null },
  { path: "/pair/place/{portfolio}", method: "post", operationId: "PairController_placePair", requestType: "PlacePairDto", responseType: null },
  { path: "/pair/{dataConfigId}/start", method: "post", operationId: "PairController_startPair", requestType: null, responseType: null },
  { path: "/pair/settings", method: "patch", operationId: "PairController_updatePairSettings", requestType: "UpdatePairSettingsDto", responseType: null },
  { path: "/pair/settings/{portfolio}", method: "get", operationId: "PairController_getPairSettings", requestType: null, responseType: null },
  { path: "/pair/orders/{dataConfigId}", method: "get", operationId: "PairController_getBotOrders", requestType: null, responseType: "PairBotOrdersResponseDto" },
  { path: "/pair/accounting/{portfolio}", method: "get", operationId: "PairController_getAccounting", requestType: null, responseType: null },
  { path: "/pair/reference-pnl/{portfolio}", method: "get", operationId: "PairController_getReferencePnl", requestType: null, responseType: null },
  { path: "/pair/admin/portfolios", method: "get", operationId: "PairAdminController_listPortfolios", requestType: null, responseType: "Array<PortfolioMappingDto>" },
  { path: "/pair/admin/strategies", method: "get", operationId: "PairAdminController_listStrategies", requestType: null, responseType: "Array<StrategyOptionDto>" },
  { path: "/pair/admin/sync/analyze", method: "post", operationId: "PairAdminController_analyze", requestType: "AnalyzeSyncRequestDto", responseType: null },
  { path: "/pair/admin/redis/scan", method: "get", operationId: "PairAdminController_redisScan", requestType: null, responseType: "Array<RedisKeyInfoDto>" },
  { path: "/pair/admin/redis/key", method: "get", operationId: "PairAdminController_redisGetKey", requestType: null, responseType: "RedisKeyValueDto" },
  { path: "/pair/admin/sync/plan", method: "post", operationId: "PairAdminController_plan", requestType: "PlanRequestDto", responseType: null },
  { path: "/pair/admin/sync/apply", method: "post", operationId: "PairAdminController_apply", requestType: "ApplySyncRequestDto", responseType: null },
  { path: "/search/stocks", method: "get", operationId: "SearchController_searchStocks", requestType: null, responseType: "StockSearchResponseDto" },
  { path: "/search/futures", method: "get", operationId: "SearchController_searchFutureContracts", requestType: null, responseType: "FutureContractSearchResponseDto" },
  { path: "/order", method: "get", operationId: "OrderController_getOrders", requestType: null, responseType: "OrdersResponseDto" },
  { path: "/performance/profit", method: "get", operationId: "PerformanceController_getProfitSummary", requestType: null, responseType: "ProfitSummaryDto" },
  { path: "/performance/metrics", method: "get", operationId: "PerformanceController_getPerformanceMetrics", requestType: null, responseType: "PerformanceMetricsDto" },
  { path: "/brokers", method: "get", operationId: "BrokerController_getActiveBrokers", requestType: null, responseType: "Array<BrokerResponseDto>" },
  { path: "/brokers", method: "post", operationId: "BrokerController_createBroker", requestType: "CreateBrokerDto", responseType: "BrokerResponseDto" },
  { path: "/brokers/all", method: "get", operationId: "BrokerController_getAllBrokers", requestType: null, responseType: "Array<BrokerResponseDto>" },
  { path: "/brokers/{id}", method: "get", operationId: "BrokerController_getBrokerById", requestType: null, responseType: "BrokerResponseDto" },
  { path: "/brokers/code/{code}", method: "get", operationId: "BrokerController_getBrokerByCode", requestType: null, responseType: "BrokerResponseDto" },
  { path: "/strategies/register", method: "post", operationId: "StrategiesController_registerStrategy", requestType: "CreateStrategyDto", responseType: "StrategyResponseDto" },
  { path: "/strategies/published", method: "get", operationId: "StrategiesController_getPublishedStrategies", requestType: null, responseType: "PaginatedStrategyResponseDto" },
  { path: "/strategies/type/{type}", method: "get", operationId: "StrategiesController_getStrategiesByType", requestType: null, responseType: "Array<StrategyResponseDto>" },
  { path: "/strategies/{id}", method: "get", operationId: "StrategiesController_getStrategyById", requestType: null, responseType: "StrategyResponseDto" },
  { path: "/strategies", method: "get", operationId: "StrategiesController_getAllStrategies", requestType: null, responseType: "Array<StrategyResponseDto>" },
  { path: "/strategies/admin/pending", method: "get", operationId: "StrategiesController_getPendingStrategies", requestType: null, responseType: "Array<StrategyResponseDto>" },
  { path: "/strategies/{id}/allow", method: "put", operationId: "StrategiesController_allowStrategy", requestType: "AllowStrategyDto", responseType: "StrategyResponseDto" },
  { path: "/strategies/{id}/reject", method: "put", operationId: "StrategiesController_rejectStrategy", requestType: "RejectStrategyDto", responseType: "StrategyResponseDto" },
  { path: "/subscriptions", method: "get", operationId: "SubscriptionController_getAllSubscriptions", requestType: null, responseType: "Array<SubscriptionResponseDto>" },
  { path: "/subscriptions", method: "post", operationId: "SubscriptionController_createSubscription", requestType: "CreateSubscriptionDto", responseType: "SubscriptionResponseDto" },
  { path: "/subscriptions/{id}/disable", method: "patch", operationId: "SubscriptionController_disableSubscription", requestType: null, responseType: "SubscriptionResponseDto" },
  { path: "/plan", method: "post", operationId: "PlanController_getPlanning", requestType: "PlanRequestDto", responseType: "PlanResponseDto" },
  { path: "/grid/config", method: "get", operationId: "GridController_listConfigs", requestType: null, responseType: "Array<GridConfigListItemDto>" },
  { path: "/grid/config", method: "post", operationId: "GridController_createConfig", requestType: "CreateGridConfigDto", responseType: "GridConfigResponseDto" },
  { path: "/grid/portfolio/{portfolioId}/config", method: "get", operationId: "GridController_getConfigsByPortfolioId", requestType: null, responseType: "Array<GridConfigResponseDto>" },
  { path: "/grid/portfolio/{portfolioId}/position", method: "get", operationId: "GridController_getGridPosition", requestType: null, responseType: "GridPositionResponseDto" },
  { path: "/grid/portfolio/{portfolioId}/profit/summary", method: "get", operationId: "GridController_getProfitSummary", requestType: null, responseType: "GridProfitSummaryDto" },
  { path: "/grid/portfolio/{portfolioId}/profit/daily", method: "get", operationId: "GridController_getProfitDaily", requestType: null, responseType: "GridDailyProfitResponseDto" },
  { path: "/grid/portfolio/{portfolioId}/profit/closed-positions", method: "get", operationId: "GridController_getClosedPositions", requestType: null, responseType: "GridClosedPositionsResponseDto" },
  { path: "/grid/config/{id}", method: "get", operationId: "GridController_getConfig", requestType: null, responseType: "GridConfigResponseDto" },
  { path: "/grid/config/{id}", method: "patch", operationId: "GridController_updateConfig", requestType: "UpdateGridConfigDto", responseType: "GridConfigResponseDto" },
  { path: "/grid/config/{id}", method: "delete", operationId: "GridController_deleteConfig", requestType: null, responseType: null },
  { path: "/grid/config/{id}/place", method: "post", operationId: "GridController_placeGrid", requestType: null, responseType: null },
  { path: "/grid/config/stop-bot", method: "post", operationId: "GridController_stopGridBot", requestType: "StopGridBotDto", responseType: null },
  { path: "/grid/config/{id}/stop", method: "post", operationId: "GridController_stopGridConfig", requestType: null, responseType: null },
  { path: "/grid/config/{id}/symbol/{symbol}", method: "delete", operationId: "GridController_deleteConfigSymbol", requestType: null, responseType: "GridConfigResponseDto" },
  { path: "/daily", method: "get", operationId: "DailyController_findAll", requestType: null, responseType: "Array<DailyScheduleResponseDto>" },
  { path: "/daily", method: "post", operationId: "DailyController_create", requestType: "CreateDailyScheduleDto", responseType: "DailyScheduleResponseDto" },
  { path: "/daily/{id}", method: "get", operationId: "DailyController_findOne", requestType: null, responseType: "DailyScheduleResponseDto" },
  { path: "/daily/{id}", method: "patch", operationId: "DailyController_update", requestType: "UpdateDailyScheduleDto", responseType: "DailyScheduleResponseDto" },
  { path: "/daily/{id}", method: "delete", operationId: "DailyController_remove", requestType: null, responseType: null },
  { path: "/tournament", method: "get", operationId: "TournamentController_findAll", requestType: null, responseType: "Array<TournamentResponseDto>" },
  { path: "/tournament", method: "post", operationId: "TournamentController_create", requestType: "CreateTournamentDto", responseType: "TournamentResponseDto" },
  { path: "/tournament/my", method: "get", operationId: "TournamentController_getMyTournaments", requestType: null, responseType: "Array<TournamentResponseDto>" },
  { path: "/tournament/{id}", method: "get", operationId: "TournamentController_findOne", requestType: null, responseType: "TournamentResponseDto" },
  { path: "/tournament/{id}", method: "patch", operationId: "TournamentController_update", requestType: "UpdateTournamentDto", responseType: "TournamentResponseDto" },
  { path: "/tournament/{id}/close", method: "post", operationId: "TournamentController_close", requestType: null, responseType: "TournamentResponseDto" },
  { path: "/tournament/{id}/reopen", method: "post", operationId: "TournamentController_reopen", requestType: null, responseType: "TournamentResponseDto" },
  { path: "/tournament/{id}", method: "delete", operationId: "TournamentController_remove", requestType: null, responseType: null },
  { path: "/tournament/{id}/participants", method: "get", operationId: "TournamentController_getParticipants", requestType: null, responseType: "Array<ParticipantResponseDto>" },
  { path: "/tournament/{id}/participants", method: "post", operationId: "TournamentController_addParticipant", requestType: "CreateParticipantDto", responseType: "ParticipantResponseDto" },
  { path: "/tournament/{id}/ranking", method: "get", operationId: "TournamentController_getRanking", requestType: null, responseType: "Array<RankingEntryDto>" },
  { path: "/tournament/{id}/participants/{participantId}", method: "delete", operationId: "TournamentController_removeParticipant", requestType: null, responseType: null },
  { path: "/strategy-execution/{id}/heartbeat", method: "post", operationId: "StrategyExecutionController_heartbeat", requestType: null, responseType: null },
  { path: "/strategy-execution/{id}/stopped", method: "post", operationId: "StrategyExecutionController_stopped", requestType: "ExecutionStoppedDto", responseType: null },
  { path: "/admin/bots", method: "get", operationId: "AdminBotsController_list", requestType: null, responseType: "Array<AdminBotRowDto>" },
  { path: "/admin/bots/{executionId}/restart", method: "post", operationId: "AdminBotsController_restartOne", requestType: null, responseType: null },
  { path: "/admin/bots/{executionId}/stop", method: "post", operationId: "AdminBotsController_stopOne", requestType: null, responseType: null },
  { path: "/admin/bots/restart-all", method: "post", operationId: "AdminBotsController_restartAll", requestType: "RestartAllBotsDto", responseType: "BulkActionResultDto" },
  { path: "/admin/bots/portfolios", method: "get", operationId: "AdminBotsController_listAdminPortfolios", requestType: null, responseType: "Array<AdminPortfolioRowDto>" },
  { path: "/admin/bots/orders/cancel-all", method: "post", operationId: "AdminBotsController_cancelAllOrders", requestType: "CancelAllOrdersDto", responseType: null },
  { path: "/admin/bots/orders/cancel-one", method: "post", operationId: "AdminBotsController_cancelOneOrder", requestType: "CancelOneOrderDto", responseType: null },
  { path: "/admin/bots/orders/place", method: "post", operationId: "AdminBotsController_manualOrder", requestType: "ManualOrderDto", responseType: null },
  { path: "/admin/bots/orders/open", method: "get", operationId: "AdminBotsController_listOpenOrders", requestType: null, responseType: null },
  { path: "/admin/bots/grid/state", method: "get", operationId: "AdminBotsController_getGridState", requestType: null, responseType: "GridStateDto" },
  { path: "/admin/bots/pair/redis-state", method: "get", operationId: "AdminBotsController_getPairRedisState", requestType: null, responseType: "PairRedisStateDto" },
  { path: "/admin/bots/pair/positions", method: "get", operationId: "AdminBotsController_getPairPositions", requestType: null, responseType: "PairPositionsDto" },
  { path: "/ai/health", method: "get", operationId: "AiController_health", requestType: null, responseType: "AiHealthResponseDto" },
  { path: "/ai/skills", method: "get", operationId: "AiController_skills", requestType: null, responseType: "Array<AiSkillDto>" },
  { path: "/ai/chat", method: "post", operationId: "AiController_chat", requestType: "AiChatRequestDto", responseType: "AiChatResponseDto" },
];
// ─── WebSocket Event Types (auto-generated from ws-schema.json) ───

export interface WsClientSubscribePayload {
  symbol: string;
}

export interface WsClientUnsubscribePayload {
  symbol: string;
}

export interface WsServerConnectedPayload {
  message?: string;
  userId?: string;
}

export interface WsServerSubscribedPayload {
  symbol?: string;
}

export interface WsServerUnsubscribedPayload {
  symbol?: string;
}

export interface WsServerErrorPayload {
  message?: string;
}

/** Socket.IO client-to-server event map (for typed emit) */
export interface WsClientToServerEvents {
  subscribe: (payload: WsClientSubscribePayload) => void;
  unsubscribe: (payload: WsClientUnsubscribePayload) => void;
}

/** Socket.IO server-to-client event map (for typed listeners) */
export interface WsServerToClientEvents {
  connected: (payload: WsServerConnectedPayload) => void;
  subscribed: (payload: WsServerSubscribedPayload) => void;
  unsubscribed: (payload: WsServerUnsubscribedPayload) => void;
  price_update: (payload: PriceResponseDto) => void;
  error: (payload: WsServerErrorPayload) => void;
}

/** WebSocket namespace and metadata */
export const WS_CONFIG = {
  namespace: "/price",
  transport: "socket.io",
} as const;
